/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.o-featured-content-module {
  min-height: 220px;
  position: relative;
  border: 1px solid var(--gray-40);
  background-color: var(--gray-5);
}
.o-featured-content-module__text {
  padding-top: 1.875em;
  padding-bottom: 1.875em;
}
.o-featured-content-module__img {
  display: block;
}
@media only all and (max-width: 37.5em) {
  .o-featured-content-module__text {
    padding-right: 0.9375em;
    padding-left: 0.9375em;
  }
  .o-featured-content-module__visual {
    padding-right: 0.9375em;
    padding-bottom: 0.9375em;
    padding-left: 0.9375em;
  }
  .o-featured-content-module__img {
    margin-right: auto;
    margin-left: auto;
  }
}
@media only all and (min-width: 37.5625em) {
  .o-featured-content-module__text {
    padding-right: 300px;
    padding-left: 1.875em;
  }
  .o-featured-content-module__visual {
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 0;
    width: 270px;
  }
  .o-featured-content-module__img {
    max-width: none;
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
.o-featured-content-module--left {
  /* Left modifier doesn't have a border/background. If in the future we
     have a left arranged FCM we'll want to make the border/background
     its own modifer */
  border: initial;
  background-color: initial;
}
.o-featured-content-module--left .o-featured-content-module__visual {
  left: 0;
  right: initial;
}
@media only all and (min-width: 37.5625em) {
  .o-featured-content-module--left .o-featured-content-module__text {
    padding-left: 300px;
    padding-right: 1.875em;
  }
}